import * as api from '@modules/conferencing/api/conferencingConfiguration';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  START,
  SUCCESS,
  ERROR,
  createRequestTypes
} from '@modules/conferencing/actions/global';

const namespace = 'CONFERENCE/CONFERENCING_CONFIGURATION';

export const CONFERENCING_CONFIGURATION_FETCH = createRequestTypes(
  `${namespace}/CONFERENCING_CONFIGURATION_FETCH`,
);

export const getConferencingConfiguration = makeApiActionCreatorV3(
  api.getConferencingConfiguration,
  CONFERENCING_CONFIGURATION_FETCH[START],
  CONFERENCING_CONFIGURATION_FETCH[SUCCESS],
  CONFERENCING_CONFIGURATION_FETCH[ERROR],
);

export const CONFERENCING_CONFIGURATION_UPDATE = createRequestTypes(
  `${namespace}/CONFERENCING_CONFIGURATION_UPDATE`,
);
  
export const updateConferencingConfiguration = makeApiActionCreatorV3(
  api.updateConferencingConfiguration,
  CONFERENCING_CONFIGURATION_UPDATE[START],
  CONFERENCING_CONFIGURATION_UPDATE[SUCCESS],
  CONFERENCING_CONFIGURATION_UPDATE[ERROR],
);
